import React from 'react';
import { DevicesTable } from './DevicesTable';

const Devices: React.FC = () => {
  return (
    <div className="mx-auto text-white">
      <DevicesTable />
    </div>
  );
};

export default Devices;
